// left side is vertical, and bottom side is horizontal  

// defines position of the verticesdakafwerking =
function positionBuffer (totaleBreedte, plankHoogte, dikte, degrees, degreesOther) {
  const radians = degrees * (Math.PI/180);
  // const r1 = (90 - degrees) * (Math.PI/180);

  const x = totaleBreedte
  const z = dikte / 2
  const h = totaleBreedte*Math.tan(radians)
  // const i = plankHoogte/(Math.sin(r1))
  const degreeMultplier = (degrees > degreesOther ? 1 : -1)
  const degreesDiff = Math.abs(degrees-degreesOther)
  const shuineZijde = plankHoogte / Math.sin((90-degrees+((degreesDiff/2)* degreeMultplier)) * (Math.PI/180))
  const i = shuineZijde * Math.cos(degreesDiff/2 * (Math.PI/180)) //plankHoogte/(Math.sin(r1)) 
  const ix = (shuineZijde * Math.sin(degreesDiff/2 * (Math.PI/180))) * degreeMultplier

  const j = plankHoogte*Math.sin(radians)
  const k = Math.sqrt((plankHoogte**2)-(j**2))

  // h   ->   0
  // h-i   ->   -i
  // 0   ->   -h
  // -k   ->   -h-k

  // x   ->   0
  // 0   ->   -x
  // j   ->   -x+j


  return [
    0, 0, z, 
    0, 0, -z, 
    ix, -i, z, 
    ix, -i, -z, 
    -x, -h, -z, 
    -x, -h, z, 
    -x+j, -h-k, -z, // j/0   -k/-y
    -x+j, -h-k, z, // j/0   -k/-y
    -x, -h, -z, 
    0, 0, -z,
    -x, -h, z, 
    0, 0, z,
    -x+j, -h-k, z, /// j/0   -k/-y
    ix, -i, z, 
    -x+j, -h-k, -z, // j/0   -k/-y
    ix, -i, -z, 
    -x, -h, z, 
    0, 0, z,
    -x+j, -h-k, z, // j/0   -k/-y
    ix, -i, z, 
    0, 0, -z,
    -x, -h, -z, 
    ix, -i, -z, 
    -x+j, -h-k, -z // j/0   -k/-y
  ]
}

// defines position of the textures
function uvBuffer (totaleBreedte, plankHoogte, dikte, degrees, degreesOther, maxTextureWith, maxTextureHeight) { 
  // //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0]
  // //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0]
  // const radians = degrees * (Math.PI/180);
  // const r1 = (90 - degrees) * (Math.PI/180);

  // const h = totaleBreedte*Math.tan(radians)
  // const i = plankHoogte/(Math.sin(r1))
  // const j = plankHoogte*Math.sin(radians)
  // const k = Math.sqrt((plankHoogte**2)-(j**2))

  // const tw = maxTextureWith || 2320
  // const th = maxTextureHeight || 145

  // return [
  //   0, i/th, 
  //   dikte/tw, i/th, 
  //   0, 0, 
  //   dikte/tw, 0,

  //   0.2, plankHoogte/th, 
  //   ((dikte/tw )+0.2), plankHoogte/th,
  //   0.2, 0, 
  //   ((dikte/tw )+0.2), 0,

  //   0.7, dikte/th, 
  //   ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.7), dikte/th, 
  //   0.7, 0, 
  //   ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.7), 0,

  //   0.3, dikte/th, 
  //   ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.3), dikte/th, 
  //   0.3, 0, 
  //   ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.3), 0,

  //   0.5, plankHoogte/th,
  //   ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.5), plankHoogte/th,
  //   0.5, 0, 
  //   ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.5), 0,

  //   Math.sqrt((totaleBreedte**2)+(h**2))/tw, plankHoogte/th,
  //   0, plankHoogte/th,
  //   Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw, 0, 
  //   0, 0,
  // ]
  const positions = positionBuffer(totaleBreedte, plankHoogte, dikte, degrees, degreesOther)
    const uvs = []
    const MAX_W = maxTextureWith || 2330
    const MAX_H = maxTextureHeight || 145
    
    // const ROTANGLE = -degrees * Math.PI / 180;
    // const ROT90 = 45 * Math.PI / 180;
  
    const degToRad = deg => deg * Math.PI / 180;
  
    // face vertex ranges (each triangle = 3 vertices)
    const faceDefs = [
      { name: "front", start: 0, end: 3, rot: 0, axes: ["x", "z"] }, // left
      { name: "right", start: 4, end: 7, rot: 0, axes: ["x", "z"] }, // right
      { name: "back", start: 8, end: 11, rot: 0, axes: ["x", "z"] }, // top
      { name: "left", start: 12, end: 15, rot: 0, axes: ["y", "z"] }, // bottom
      { name: "top", start: 16, end: 19, rot: -degrees, axes: ["x", "y"] }, // front
      { name: "bottom", start: 20, end: 23, rot: -degrees, axes: ["x", "y"] }, // back
    ];
  
    let vertexIndex = 0;          // counts vertices, not floats
    for (let i = 0; i < positions.length; i += 3, vertexIndex++) {
      let x = positions[i];
      let y = positions[i + 1];
      let z = positions[i + 2];
  
      // figure out which face this vertex belongs to
      let face = faceDefs.find(f => vertexIndex >= f.start && vertexIndex <= f.end);
      if (!face) face = { rot: 0, axes: ["x", "y"] }; // fallback
  
      const angle = degToRad(face.rot);
      const cos = Math.cos(angle);
      const sin = Math.sin(angle);
  
      // get UV axes
      let a1, a2;
      switch (face.axes[0]) {
        case "x": a1 = -x; break;
        case "y": a1 = -y; break;
        case "z": a1 = -z; break;
      }
      switch (face.axes[1]) {
        case "x": a2 = -x; break;
        case "y": a2 = -y; break;
        case "z": a2 = -z; break;
      }
  
      // rotate in 2D (in the local plane)
      const u_ = a1 * cos - a2 * sin;
      const v_ = a1 * sin + a2 * cos;
  
      // scale to UV space
      const u = u_ / MAX_W;
      const v = v_ / MAX_H;
  
      uvs.push(u, v);
    }
  
    return uvs
}

// defines orientation of the faces (texture inside or outside)
function normalBuffer () {
  //return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
  //return [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,]
  //return [0,0,1]
  return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
}

// defines the shared vertices of position and uv buffer (corners have overlapping vertices which can be refenreced by index instead of defining an new verticie)
function indexBuffer () {
  /*return [
    0,  1,  2,   2,  1,  3,  // front
    4,  5,  6,   6,  5,  7,  // right
    8,  9, 10,  10,  9, 11,  // back
   12, 13, 14,  14, 13, 15,  // left
   16, 17, 18,  18, 17, 19,  // top
   20, 21, 22,  22, 21, 23,  // bottom
  ]*/
  return [0, 2, 1, 2, 3, 1, 4, 6, 5, 6, 7, 5, 8, 10, 9, 10, 11, 9, 12, 14, 13, 14, 15, 13, 16, 18, 17, 18, 19, 17, 20, 22, 21, 22, 23, 21]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

export { positionBuffer, uvBuffer, normalBuffer, indexBuffer, groupBuffer }